import { useTheme } from "@mui/material";
import { FC } from "react";
import { useLocalization } from "../hooks/useLocalization";
import { ConfirmationDialog } from "./ConfirmationDialog";

interface GrantAccessSuccessDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
}

export const GrantAccessSuccessDialog: FC<GrantAccessSuccessDialogProps> = ({
  isOpen,
  onClose,
  title,
  message,
}) => {
  const { t } = useLocalization();
  const theme = useTheme();

  return (
    <ConfirmationDialog.Root
      aria-describedby="add-user-description"
      aria-labelledby="add-user-title"
      fullWidth
      maxWidth="xs"
      onClose={onClose}
      open={isOpen}
      sx={{
        "& .MuiDialog-container": {
          alignItems: "flex-start",
          paddingTop: 8,
        },
      }}
    >
      <ConfirmationDialog.Title
        iconType="success"
        id="add-user-title"
        showIcon={true}
      >
        {title ?? t("components.grantAccessSuccessDialog.title")}
      </ConfirmationDialog.Title>
      <ConfirmationDialog.Content
        sx={{ fontWeight: 500, color: theme.colors.text[1], fontSize: 14 }}
      >
        {message ?? t("components.grantAccessSuccessDialog.message")}
      </ConfirmationDialog.Content>
      <ConfirmationDialog.Actions>
        <ConfirmationDialog.Button
          onClick={onClose}
          sx={{ height: 40, borderRadius: "8px" }}
          variant="contained"
        >
          {t("components.grantAccessSuccessDialog.confirm")}
        </ConfirmationDialog.Button>
      </ConfirmationDialog.Actions>
    </ConfirmationDialog.Root>
  );
};
